import * as amplify from "./amplify.ts";
import * as i18n from "../i18n.ts";
import * as libLocation from "../lib/location.ts";
import * as modal from "./modal.ts";
import ApiServer from "../ApiServer.js";
import * as Html from "./Html.ts";
import * as FwDatas from "../FwDatas.ts";
import * as modalListCategories from "../ui/modal/listCategories.js";
import TPL_TASK_CONTAINER_CONTENT from "../list/task-container-content.mustache";
import toUnicodeVariant from "../lib/toUnicodeVariant/toUnicodeVariant.js"
import Icons from "../svg/Icons.ts";
import { registerDragStart} from "../lib/FileUtils.ts";
import $ from "../$.js";
import { MetaTaskCache } from "../server/objects/TaskBeans.ts";
import TPL_tasklist_list_item from "../list/tasklist_list_item.mustache"
import TPL_task_item from "../list/task.mustache"


function listcreatereally(type){
  modal.closeModal();
  import("../list/list_create.mustache").then(function(TPL){
    var 
      theModal = modal.openModal(TPL,new ApiServer.types.ITaskList({taskListType:type,sharedToAll:"true",rights:{},sharedMemberIds:[]})),
      form = theModal.find("form");
    form.attr('data-fw-dyn-action','custom.listcreate');
    ApiServer["custom.listcreate"] = ApiServer.taskcreatelist.prepare(function(cat){
      modal.closeModal(theModal);
      amplify.publish("taskNeedRefresh");
      libLocation.goTo('?metaId='+cat.metaId,true)
    });
  });
}

Html.register({
  async taskmarkinlist(complete){
    let 
      node = this.metaIdNode(),
      metaId = this.metaId(),
      [updated,[lists]] = await Promise.all(
        [
          ApiServer.taskmark.setOptions({progressbar:'none'})(metaId,complete),
          MetaTaskCache.refresh()
        ]),
      currentList = lists.find(list=>list.metaId === updated.taskListId),    
      listItemNode = $('.selectable>*[data-fw-meta-id="'+currentList.metaId+'"]'),
      isSelected = listItemNode.hasClass('selected');

    listItemNode = Html.replaceWith($('.selectable>*[data-fw-meta-id="'+currentList.metaId+'"]'),TPL_tasklist_list_item,currentList)
    if(listItemNode){
      listItemNode.toggleClass('selected',isSelected)
    }
    
    Html.replaceWith(node,TPL_task_item,updated)
  },
  async listcreate(){
    var button = await modal.pick({
      title:"catsystem.picktype",
      cssClass:"large",
      gap:"var(--space-s)",
      button:[
        {title:"catsystem.SYS-CAT-SHOPPINGLIST",text:"catsystem.SYS-CAT-SHOPPINGLISTtext",icon:Icons.list.create_list_type_illustration_groceries,onclick:()=>listcreatereally("SHOPPING_LIST")},
        {title:"catsystem.SYS-CAT-TODOS",text:"catsystem.SYS-CAT-TODOStext",icon:Icons.list.create_list_type_illustration_todo,onclick:()=>listcreatereally("TODOS")},
        {title:"catsystem.SYS-CAT-OTHER",text:"catsystem.SYS-CAT-OTHERtext",icon:Icons.list.create_list_type_illustration_other,onclick:()=>listcreatereally("OTHER")}
        
      ]})
    if(button){
      button.onclick()
    }
    
  },
  listcreatereally,

  listdelete(){
    var 
      catNode = this.metaIdNode(),
      list = FwDatas.get([catNode.metaId()]);
    modal.closeModal();
    modal.confirmDelete({
      message:'catsystem.deleteconfirm',
      yes:"actions.confirm",
      no:"actions.cancel"
    },function(){
      ApiServer.taskdeletelist.setOptions({node:catNode})(list.metaId);
      amplify.publish("taskNeedRefresh");
    });
    
  },
  listedit(){
    var 
      catNode = this.metaIdNode(),
      list = FwDatas.get([catNode.metaId()]);
    import("../list/list_create.mustache").then(function(TPL){
      var 
        theModal = modal.openModal(TPL,list),
        form = theModal.find("form");
      
      form.attr('data-fw-dyn-action','custom.listedit')
      ApiServer['custom.listedit'] = ApiServer.taskupdatelist.prepare({metaId:list.metaId},function(){
        amplify.publish("taskNeedRefresh")
        modal.closeModal(theModal);
      });
    });
  },
  listeditsharing(){
    var 
      catNode = this.metaIdNode(),
      list = FwDatas.get([catNode.metaId()]);
    import("../list/list_editsharing.mustache").then(function(TPL){
      var theModal = modal.openModal(TPL,list);
      theModal.find("form").on("submit",function(evt){
        evt.preventDefault();
        modal.closeModal(theModal);
        ApiServer.taskupdatelist(this)
        amplify.publish("taskNeedRefresh")
      });
    });
  },
  listshowhidecompleted(completedHidden){
    var 
      metaId = this.metaId();
    
    //do not send all list beause of a serveur bug
    ApiServer.taskupdatelist({metaId,completedHidden});
    amplify.publish('taskNeedRefresh')
  
  },
  taskmarkall(){
    var 
      metaId = this.metaId();
    
    ApiServer.taskmetamark([metaId],true);
    amplify.publish("taskNeedRefresh")
   },
  taskunmarkall(){
    var 
      metaId = this.metaId();
    
    ApiServer.taskmetamark([metaId],false);
    
    amplify.publish("taskNeedRefresh")
  },
  taskdeletemarked(){
    var 
      catNode = this.metaIdNode(),
      list = FwDatas.get([catNode.metaId()]),
      ids = list.complete.filter(function(task){return task.editable}).map(function(task){return task.metaId}),
      makeCall = ids.length>0,
      modalAfterNeeded = ids.length<list.complete.length;
    
    if(makeCall){
      ApiServer.metadelete.setOptions({node:catNode})(ids,function(){
        if(modalAfterNeeded){
         modal.alert("catsystem.alertnotalldeleted")
        }
      });
      amplify.publish("taskNeedRefresh");
    }else if(modalAfterNeeded){
      modal.alert("catsystem.alertnotalldeleted")
    }  
  },
  taskduplicatelist(){
    var 
      catNode = this.metaIdNode();
    
    ApiServer.taskduplicatelist(catNode.metaId(),function(newList){
      modal.snackDone('catsystem.duplicatedone')
      libLocation.goTo('?metaId='+newList.metaId,true)
    });
    amplify.publish("taskNeedRefresh")
  },
  tasklistsort(sortby){
    var 
      catNode = this.metaIdNode(),
      list = FwDatas.get([catNode.metaId()]);
  
    list.taskSorting = sortby;
    //do not send all list beause of a serveur bug
    ApiServer.taskupdatelist.setOptions({progressbar:'none'})({metaId:list.metaId,taskSorting:sortby});
    list.sort();
    import("../list/tasksortby.mustache").then(function(TPLSORT){
      Html.setHtml(catNode.find('#task-container'),TPL_TASK_CONTAINER_CONTENT,list);
      Html.setHtml(catNode.find('.fw-sorting-tasks'),TPLSORT,list);
    });
  },
  
  tasklistcategoryhide(hide){
    var 
      catNode = this.metaIdNode(),
      list = FwDatas.get([catNode.metaId()]);
    list.taskCategoriesHidden = hide;
    ApiServer.taskupdatelist.setOptions({progressbar:'none'})({metaId:list.metaId,taskCategoriesHidden:hide});
    amplify.publish("taskNeedRefresh");
  },
  async listshare(){
    var 
      catNode = this.metaIdNode(),
      list = FwDatas.get([catNode.metaId()]),
      taskByCategory = list.taskByCategory(),
      text;
      
    if(list.taskCategoriesHidden){
      text = `${list.name}
${list.ongoing.map(task=>`  □ ${task.text}`).join('\r\n')}
${list.complete.map(task=>`  ✓ ${task.text}`).join('\r\n')}
`;
    }else{
      text = `${toUnicodeVariant(list.name.toLocaleUpperCase(),'bold')}
${taskByCategory.map(pair=>`
${pair.category.emoji}\t${toUnicodeVariant(pair.category.name.toLocaleUpperCase(),'bold')}
${pair.items.map(task=>`\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0${task.computedComplete?'🗹':'❏'}\u00a0\u00a0${toUnicodeVariant(task.text,'italic',task.complete?'strike':undefined)}`).join('\n')}
`).join('')}      

${i18n.get('share.footer')}
\u00a0
`;
    }     
    try{
      await navigator.share({text})  
    }catch(e){
      modal.oops('fw2.defaultError')
    }
  }

  
});

ApiServer["custom.taskquickadd"] = function(form){
  var 
    catNode = $(form).metaIdNode(),
    metaId = catNode.metaId(),
    list = FwDatas.get([catNode.metaId()]),
    formData = ApiServer.flattenForm(form),
    text = formData.text[0];
  
  setTimeout(function(){
    form.reset();
    //TODO understand why the reset does not do that
    form.taskCategoryId.value='';
  },0)
 // focusListId = list.metaId;
  
  //check if we unmark
  var completeTaskWithSameName = list.complete.filter(function(task) {
    return formData.text.indexOf(task.text)>-1;
  })[0];
  
  if(completeTaskWithSameName){
    ApiServer.taskmark(completeTaskWithSameName.metaId,false);
    ApiServer.taskmove(completeTaskWithSameName.metaId);
  }else if(text.indexOf('http')===0){
    
    ApiServer.webog(text,function(ogBean){
      
      formData.description = formData.text;
      formData.text = ogBean.title||formData.text;
      ApiServer.taskcreate2(formData);
      amplify.publish("taskNeedRefresh")
    })
    return;
  }else{  
    ApiServer.taskcreate2(formData);
  }
  amplify.publish("taskNeedRefresh")
  amplify.subscribe("taskRefreshed",function refocus(){
    setTimeout(()=>$('.fw-todoAdd').focus(),50);
    amplify.unsubscribe("taskRefreshed",refocus)
  })
}

$(document).on("selectstart",'.fw-todo ',function(ev){
  ev.preventDefault()
});

/* with sorting */ 
registerDragStart(".fw-todo",async function(ev,dropPromiseBuilder){
  var 
    dropEvent = await dropPromiseBuilder(this,document.querySelectorAll(".fw-todo, .fw-category-header, .fw-tasklist-header")),
    metaId = $(this).metaId(),
    target = $(dropEvent.target);

  if(target.hasClass('fw-todo')){
    var 
      prevTaskNode = target.metaIdNode(),
      categoryNode = target.parents('.fw-category-header');
    
    if($(ev.target).offset().top + $(ev.target).height()/2>ev.clientY){
      prevTaskNode = prevTaskNode.prev();
    }
    ApiServer.taskmove({taskId:metaId,prevTaskId:prevTaskNode.metaId(),taskCategoryId:categoryNode.metaId()})
  }else if(target.hasClass('fw-category-header')){
    ApiServer.taskmove({taskId:metaId,taskCategoryId:target.metaId()||'$empty'})
  
  }else if(target.hasClass('fw-tasklist-header')){
    ApiServer.taskmove({taskId:metaId,taskListId:target.metaId()||'$empty'})
  
  }
  amplify.publish("taskNeedRefresh")
  
});